import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "tutorial-help-shell"
};
const _hoisted_2 = {
    key: 0,
    class: "tutorial-context-banner",
    role: "region",
    "aria-label": "Ayuda contextual"
};
import { ref, watch, onBeforeUnmount, computed } from "vue";
import { useRoute } from "vue-router";
import TutorialHelpBottomSheet from "@/components/TutorialHelpBottomSheet.vue";
import { useContextualTutorials } from "@/composables/useContextualTutorials";
import { useContextualInteractiveGuides } from "@/composables/useContextualInteractiveGuides";
import { useInteractiveHelpStore } from "@/store/interactiveHelpStore";
import { useCursoStore } from "@/store/cursoStore";
import { isScreenHelpDismissed } from "@/help/persistence";
const APP_BANNER_CLASS = "tutorial-banner-active";
const BANNER_HEIGHT = "40px";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TutorialHelpBanner',
    setup(__props) {
        const route = useRoute();
        const { contextualDemos, showTutorialFab } = useContextualTutorials();
        const { contextualGuides } = useContextualInteractiveGuides();
        const helpStore = useInteractiveHelpStore();
        const cursoStore = useCursoStore();
        const sheetOpen = ref(false);
        const routeName = computed(() => typeof route.name === "string" ? route.name : "");
        const hasHelpResources = computed(() => (showTutorialFab.value || contextualGuides.value.length > 0) &&
            Boolean(routeName.value));
        const showTopBanner = computed(() => hasHelpResources.value && !isScreenHelpDismissed(routeName.value));
        const syncAppBannerClass = (active) => {
            const app = document.getElementById("app");
            if (!app)
                return;
            app.classList.toggle(APP_BANNER_CLASS, active);
            app.style.setProperty("--tutorial-banner-height", active ? BANNER_HEIGHT : "0px");
        };
        const abrirSheet = () => {
            sheetOpen.value = true;
        };
        const cerrarSheet = () => {
            sheetOpen.value = false;
        };
        const iniciarGuiaInteractiva = (guideId) => {
            sheetOpen.value = false;
            const curso = cursoStore.getCursoData();
            const treasuryType = curso?.treasury_type === "centro_costos" ? "centro_costos" : "cuotas";
            const guideContext = { treasuryType };
            if (guideId === "funds.paradigm-intro") {
                guideContext.hasNoFunds = Boolean(document.querySelector('[data-help-id="funds-empty-intro"]'));
            }
            if (guideId === "sales.manage-intro") {
                guideContext.hasNoSaleCampaigns = Boolean(document.querySelector('[data-help-id="sales-manage-empty"]'));
            }
            if (guideId === "sales.buy-intro") {
                guideContext.hasActiveSaleCampaigns = Boolean(document.querySelector('[data-help-id="sales-buy-list"]'));
            }
            if (guideId === "donations.commit-intro") {
                guideContext.hasActiveDonationCampaigns = Boolean(document.querySelector('[data-help-id="donations-buy-list"]'));
            }
            if (guideId === "donations.manage-intro") {
                guideContext.hasNoDonationCampaigns = Boolean(document.querySelector('[data-help-id="donations-manage-empty"]'));
            }
            if (guideId === "payments.validate-intro") {
                const root = document.querySelector('[data-help-id="payments-validate-root"]');
                guideContext.hasPendingPayments =
                    root?.getAttribute("data-has-pending") === "true";
            }
            if (guideId === "invite.link-intro") {
                guideContext.hasGeneratedInviteLink = Boolean(document.querySelector('[data-help-id="invite-link-result"]'));
            }
            if (guideId === "payments.register-intro") {
                guideContext.skipMisPagosStep = routeName.value !== "mis-pagos";
            }
            if (guideId === "expenses.view-intro") {
                guideContext.hasNoExpenses = Boolean(document.querySelector('[data-help-id="expenses-view-empty"]'));
                guideContext.canRegisterExpense = Boolean(document.querySelector('[data-help-id="expenses-view-fab"], [data-help-id="expenses-view-empty-action"]'));
            }
            if (guideId === "incomes.view-intro") {
                guideContext.hasNoIncomes = Boolean(document.querySelector('[data-help-id="incomes-view-empty"]'));
                guideContext.canRegisterIncome = Boolean(document.querySelector('[data-help-id="incomes-view-fab"], [data-help-id="incomes-view-empty-action"]'));
            }
            helpStore.startGuide(guideId, guideContext);
        };
        watch(showTopBanner, (active) => {
            syncAppBannerClass(active);
            if (!active) {
                sheetOpen.value = false;
            }
        }, { immediate: true });
        watch(() => route.name, () => {
            sheetOpen.value = false;
        });
        onBeforeUnmount(() => {
            syncAppBannerClass(false);
        });
        return (_ctx, _cache) => {
            return (hasHelpResources.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (showTopBanner.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "tutorial-context-banner-btn",
                                "aria-label": "Ver ayuda de esta pantalla",
                                onClick: abrirSheet
                            }, _cache[0] || (_cache[0] = [
                                _createElementVNode("i", {
                                    class: "bi bi-play-circle tutorial-context-banner-icon",
                                    "aria-hidden": "true"
                                }, null, -1),
                                _createElementVNode("span", { class: "tutorial-context-banner-text" }, [
                                    _createTextVNode(" Aprende a usar esta opción· "),
                                    _createElementVNode("strong", null, "Ver tutorial")
                                ], -1),
                                _createElementVNode("i", {
                                    class: "bi bi-chevron-right tutorial-context-banner-chevron",
                                    "aria-hidden": "true"
                                }, null, -1)
                            ]))
                        ]))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "tutorial-help-fab",
                            "aria-label": "Abrir ayuda de esta pantalla",
                            onClick: abrirSheet
                        }, _cache[1] || (_cache[1] = [
                            _createElementVNode("i", {
                                class: "bi bi-question-circle",
                                "aria-hidden": "true"
                            }, null, -1)
                        ]))),
                    _createVNode(TutorialHelpBottomSheet, {
                        show: sheetOpen.value,
                        demos: _unref(contextualDemos),
                        guides: _unref(contextualGuides),
                        onClose: cerrarSheet,
                        onStartGuide: iniciarGuiaInteractiva
                    }, null, 8, ["show", "demos", "guides"])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
